/**
 * cells/InvestedCell.tsx
 *
 * Displays the investment amount for a unit.
 * Shows planned or actueel total based on the page-level toggle.
 * Sub-line renders energetisch € (brick) + other € (neutral) as a compact pip.
 */
import { EPCData } from "shared/components/maintenance/hooks/useEnergyPerformanceData";
import { formatEuro } from "shared/components/renovation/helpers/formatCurrency";

interface InvestedCellProps {
  unit: EPCData;
  mode: "planned" | "actueel";
}

export function InvestedCell({ unit, mode }: InvestedCellProps) {
  const investment = unit.investment;
  const total =
    mode === "planned"
      ? investment.plannedTotal
      : investment.actualTotal;

  const energetisch =
    mode === "planned"
      ? investment.byCategory.energetisch.planned
      : investment.byCategory.energetisch.actual;

  const other = total - energetisch;

  if (total === 0) {
    return (
      <span className="text-neutral-secondary-mid text-xs italic">—</span>
    );
  }

  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-neutral-primary text-sm font-semibold">
        {formatEuro(total)}
      </span>
      {energetisch > 0 && (
        <div className="flex items-center gap-1 text-xs">
          <span className="text-brick-primary font-medium">
            {formatEuro(energetisch)}
          </span>
          {other > 0 && (
            <>
              <span className="text-neutral-secondary-mid">+</span>
              <span className="text-neutral-secondary-mid">
                {formatEuro(other)}
              </span>
            </>
          )}
        </div>
      )}
    </div>
  );
}
